import { forwardRef } from "react";
// @mui
import { useTheme } from "@mui/material/styles";
import Link from "@mui/material/Link";
import Box, { BoxProps } from "@mui/material/Box";
// routes
import { RouterLink } from "../../routes/components";

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const theme = useTheme();

    const logo = (
      <Box
        ref={ref}
        component="div"
        sx={{
          width: 70,
          height: 45,
          display: "inline-flex",
          ...sx,
        }}
        {...other}
      >
        <img src="/logo/logo.svg" />
      </Box>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link
        component={RouterLink}
        href="/dashboard"
        sx={{ display: "contents" }}
      >
        {logo}
      </Link>
    );
  }
);

export default Logo;
